<template>
  <v-container fluid class="tb-layout-browse1 rv-page">
    <v-card class="pa-2 rv-card-wrapper">
      <!-- Page header -->
      <div class="page-toolbar">
        <div class="page-toolbar__left">
          <h1 class="page-toolbar__title">{{ headerTitle }}</h1>
          <span id="record-count" class="page-toolbar__count"></span>
        </div>
        <div class="page-toolbar__right">
          <button class="new-app-btn" @click="$router.push({ name: 'AddHrdcApplication' })">
            <v-icon size="16" color="#fff" class="mr-1">mdi-plus</v-icon>
            New Application
          </button>
          <v-btn-toggle dense multiple class="mr-1">
            <BreadTabulatorExportAll
              ref="exportData"
              :model="model"
              :apiUrl="apiGetBrowseUrl()"
              @downloadData="downloadData"
            ></BreadTabulatorExportAll>
          </v-btn-toggle>
        </div>
      </div>

      <!-- Filter Toggle -->
      <div class="filter-bar">
        <button class="filter-bar__toggle" @click="isShow = !isShow">
          <v-icon size="16" color="var(--app-text-muted)" class="mr-1">mdi-filter-variant</v-icon>
          <span>Filter</span>
          <span v-if="conditions.length > 0" class="filter-bar__badge">{{ conditions.length }}</span>
          <v-icon size="16" color="var(--app-text-faint)" class="ml-1">{{ isShow ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </button>
      </div>

      <!-- Collapsible Filter Panel -->
      <div v-show="isShow" class="filter-panel">
        <BreadTabulatorFilterable
          ref="filter"
          :model="model"
          :setConditions="setConditions"
        ></BreadTabulatorFilterable>

        <div class="filter-panel__divider"></div>

        <div class="filter-panel__columns">
          <BreadTabulatorSelectColumn
            ref="selectColumn"
            :model="model"
            @applyColumnSelection="applyColumnSelection"
          ></BreadTabulatorSelectColumn>
        </div>
      </div>

      <!-- Search bar -->
      <div class="page-search">
        <BreadTabulatorSearchable
          ref="search"
          :model="model"
          :setConditions="setConditions"
        ></BreadTabulatorSearchable>
      </div>

      <BreadTabulatorViewLatest
        ref="customView"
        :model="model"
        :selectedCustomColums="selectedCustomColums"
        :selectedAdvanceFilterConditions="selectedAdvanceFilterConditions"
        :selectedFilterConditions="selectedFilterConditions"
        :cColumnSort="cColumnSort"
        :displayRowCount="displayRowCount"
        :listAllViews="listAllViews"
        :allResizeColumns="allResizeColumns"
        @changeTableDetails="changeTableDetails"
      ></BreadTabulatorViewLatest>

      <div class="table-scroll-wrapper">
        <BreadDataTable
          ref="tabulatorDataTable"
          layout="fitColumns"
          :autoColumns="false"
          :paginationSize="paginationSize"
          :paginationSizeSelector="paginationSizeSelector"
          :apiUrl="apiGetBrowseUrl()"
          :columns="columns"
          :modelKey="modelKey"
          :deferInitialLoad="true"
          :columnSelectionDisabledCount="columnSelectionDisabledCount"
          @getCurrentPageSize="getCurrentPageSize"
          @getCurrentSort="getCurrentSort"
          @getCurrentColumnWidth="getCurrentColumnWidth"
          @getCurrentPageNumber="getCurrentPageNumber"
        ></BreadDataTable>
      </div>

      <v-dialog
        v-model="flagDialog"
        max-width="500"
        content-class="rv-dialog"
        @click:outside="clearErrorMsg()"
      >
        <div class="rv-dialog__card">
          <div class="rv-dialog__header">
            <v-icon size="20" color="#fff" class="mr-2">mdi-flag-outline</v-icon>
            <span class="rv-dialog__title">Add a Remark</span>
            <v-spacer></v-spacer>
            <button class="rv-dialog__close" @click="closeUpdateFlagAndRemarkDialog()">
              <v-icon size="18" color="rgba(255,255,255,0.7)">mdi-close</v-icon>
            </button>
          </div>
          <div class="rv-dialog__body">
            <div v-if="api.error" class="rv-dialog__error">
              <v-icon small color="#dc2626" class="mr-2">mdi-alert-circle-outline</v-icon>
              {{ api.error }}
            </div>

            <label class="rv-dialog__label">Remark</label>
            <v-textarea
              v-model="flagRemarks"
              :error-messages="errorField.flagRemarks"
              auto-grow
              filled
              placeholder="Enter remark..."
              class="rv-textarea"
              hide-details="auto"
            ></v-textarea>
            <div class="rv-dialog__hint">
              <v-icon size="14" color="var(--app-text-faint)" class="mr-1">mdi-information-outline</v-icon>
              Flag case is required to put remarks
            </div>
          </div>

          <div class="rv-dialog__actions">
            <button
              class="rv-dialog__btn rv-dialog__btn--cancel"
              @click="closeUpdateFlagAndRemarkDialog()"
            >Cancel</button>
            <button
              v-if="flagOrUnflagText == 'Unflag'"
              class="rv-dialog__btn rv-dialog__btn--secondary"
              @click="updateFlagRemarkOnly()"
            >Update Remark</button>
            <button
              class="rv-dialog__btn rv-dialog__btn--confirm"
              @click="updateFlagAndRemark()"
            >{{ flagOrUnflagText }}</button>
          </div>
        </div>
      </v-dialog>
    </v-card>
  </v-container>
</template>
<script>
import store from "@/store";
import { mapState } from "vuex";
import Api from "@/objects/api";
import Model from "@/objects/model";
import Service from "@/objects/service";
import hrdcFunction from "@/objects/hrdcFunction";
import HrdcData from "@/services/hrdc/objects/globalData";

export default {
  mixins: [hrdcFunction],
  components: {},
  computed: {
    ...mapState({
      auth: (state) => state.auth.data,
      hrdc: (state) => state.hrdc.data,
    }),
    headerTitle() {
      return `${process.env.VUE_APP_SERVICE_HRDC_TAXPOD_APP_NAME} ${this.model.name.plural}`;
    },
  },
  props: ["params"],
  data: () => ({
    api: new Api(),
    conditions: [],
    model: new Model(),
    service: new Service(),
    hrdcData: new HrdcData(),
    listAllViews: [],
    columns: [],
    paginationSize: 10,
    paginationSizeSelector: [10, 50, 100, 200, 500],
    modelKey: "",
    parentId: "",
    cColumnSort: [],
    displayRowCount: 10,
    selectedCustomColums: [],
    selectedAdvanceFilterConditions: [],
    selectedFilterConditions: [],
    switchToAdvanceFilter: false,
    isShow: false,
    allResizeColumns: [],
    columnSelectionDisabledCount: 5,
    currentPageNo: 1,
    flagDialog: false,
    flagDetails: null,
    flagRemarks: null,
    flagOrUnflagText: "Flag",
    errorField: {
      flagRemarks: null,
    },
  }),
  async created() {
    this.model.getByKey(this.params.modelKey);
    if (this.model.serviceKey) this.service.set("key", this.model.serviceKey);
    this.modelKey = this.$route.params.modelKey;
    this.parentId = this.$route.params.parentId;

    this.columns = this.$_.filter(
      this.model.browse.table.headers,
      (headers) => {
        return headers;
      }
    );

    var columnIndex = 0;
    for (var column of this.columns) {
      // Add click company cell direct to view details.
      if (column.field == "company") {
        this.columns[columnIndex].cellClick = (e, cell) => {
          const {
            applicationUuid,
            stageId,
            firstNameAccEnrollment,
            lastNameAccEnrollment,
            contactNoAccEnrollment,
            emailAccEnrollment,
          } = cell.getData();

          this.$store.commit("assignHrdcData", {
            applicationUuid,
            stageId,
            firstNameAccEnrollment,
            lastNameAccEnrollment,
            contactNoAccEnrollment,
            emailAccEnrollment,
            viewId: this.$route.query.viewId,
          });

          this.$router.push({
            name: "ViewHrdcApplication",
            query: {
              currentPageNo: this.currentPageNo,
              _ausk: applicationUuid,
              // Carry the current view so "back" returns to the same view.
              viewId: this.$route.query.viewId,
            },
          });
        };

        this.columns[columnIndex].contextMenu = [
          {
            label: "View Details",
            action: (_, cell) => {
              const {
                applicationUuid,
                stageId,
                firstNameAccEnrollment,
                lastNameAccEnrollment,
                contactNoAccEnrollment,
                emailAccEnrollment,
              } = cell.getData();

              this.$store.commit("assignHrdcData", {
                applicationUuid,
                stageId,
                firstNameAccEnrollment,
                lastNameAccEnrollment,
                contactNoAccEnrollment,
                emailAccEnrollment,
                viewId: this.$route.query.viewId,
              });

              const routeData = this.$router.resolve({
                name: "ViewHrdcApplication",
                query: {
                  currentPageNo: this.currentPageNo,
                  _ausk: applicationUuid,
                  // Carry the current view so "back" returns to the same view.
                  viewId: this.$route.query.viewId,
                },
              });
              window.open(routeData.href, "_blank");
            },
          },
        ];
      }

      columnIndex++;
    }

    this.columns.push({
      title: "Flag",
      field: "applicationUuid",
      dataType: "onlyLikeEqualNotEqual",
      filterable: true,
      searchable: true,
      sortable: false,
      headerFilter: false,
      selectableColumn: true,
      hozAlign: "left",
      headerWordWrap: true,
      headerSort: false,
      width: "80",
      formatter: (cell) => {
        const data = cell.getData();
        const flagVal = data.isFlag;
        return this.flagCol(flagVal);
      },
      cellClick: (e, cell) => {
        const data = cell.getData();
        const flagVal = data.isFlag;
        let flagText = "Unflag";
        if (!flagVal) {
          flagText = "Flag";
        }

        // Add the flag text here.
        this.flagOrUnflagText = flagText;

        this.flagRemarks = data.flagRemarks;
        this.flagDialog = !this.flagDialog;
        this.flagDetails = cell;
      },
    });

    this.columns.push({
      title: "Next Action",
      headerSort: false,
      hozAlign: "center",
      headerHozAlign: "center",
      width: "100",
      formatter: function () {
        return `<button class="tbl-next-btn" title="Go to next step"><i aria-hidden="true" class="v-icon notranslate mdi mdi-arrow-right theme--light"></i></button>`;
      },
      htmlOutput: true,
      cellClick: (_, cell) => {
        const viewId = this.$route.query.viewId;
        const applicationUuid = cell.getRow().getData().applicationUuid;
        const data = cell.getData();

        // If application deleted, redirect to View Details page.
        if (data.timestampDeleted) {
          this.$router.push({
            name: "ViewHrdcApplication",
            query: {
              currentPageNo: this.currentPageNo,
              _ausk: applicationUuid, // ausk=Application UUID Secret Key
              // Carry the current view so "back" returns to the same view.
              viewId: this.$route.query.viewId,
            },
          });

          return;
        }

        const stageId = data.stageId;
        const firstNameAccEnrollment = data.firstNameAccEnrollment;
        const lastNameAccEnrollment = data.lastNameAccEnrollment;
        const contactNoAccEnrollment = data.contactNoAccEnrollment;
        const emailAccEnrollment = data.emailAccEnrollment;
        const paymentChannel = data.paymentChannel;

        // Construct next form to redirect.
        let route = this.nextFormRedirect(stageId, paymentChannel);
        let params = {
          applicationUuid,
          stageId,
          firstNameAccEnrollment,
          lastNameAccEnrollment,
          contactNoAccEnrollment,
          emailAccEnrollment,
          viewId,
        };

        if (route !== "") {
          store.commit("assignHrdcData", params);

          this.$router.push({
            name: route,
            query: {
              currentPageNo: this.currentPageNo,
              _ausk: applicationUuid, // ausk=Application UUID Secret Key
              // Carry the current view so "back" returns to the same view.
              viewId,
            },
          });
        }
      },
    });

    this.columns.push({
      title: "Actions",
      headerSort: false,
      hozAlign: "center",
      headerHozAlign: "center",
      formatter: function () {
        return `<button class="tbl-actions-btn">Actions <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg></button>`;
      },
      htmlOutput: true,
      clickMenu: (e, cell) => {
        const cellData = cell.getData();
        const paymentChannel = cellData.isPaymentMade;
        const options = [
          { label: "View Details", value: "ViewHrdcApplication" },
          { label: "Edit Details", value: "EditHrdcApplication" },
          { label: "General Info", value: "AddGeneralInfo" },
          { label: "Send HRDC Email to Client", value: "SendHrdcEmailToClient" },
          { label: "Grant Approval & Revert Form", value: "ClientRevertForm" },
          { label: "Manual Invoice to HRDC", value: "ManualInvoiceToHrdc" },
          { label: "Claim Submitted to HRDC", value: "ClaimSubmitToHrdc" },
          { label: "Claim Approved from HRDC", value: "ClaimApprovedFromHrdc" },
          { label: "Payment Received from HRDC", value: "PaymentReceivedFromHrdc" },
        ];

        if (paymentChannel) {
          options.push(
            { label: "Refund Email Submission", value: "RefundEmailSubmission" },
            { label: "Refund Email Approval 1", value: "RefundEmailApproval1" },
            { label: "Refund Email Approval 2", value: "RefundEmailApproval2" },
            { label: "Refund Email AR to AP", value: "RefundEmailArToAp" },
            { label: "Email Payment Advice to Client", value: "EmailPaymentAdviceToClient" }
          );
        }

        if (!paymentChannel) {
          options.push({ label: "Enrollment Detail", value: "EnrollmentDetail" });
        }

        return options.map((opt) => ({
          label: opt.label,
          action: () => {
            const viewId = this.$route.query.viewId;
            const applicationUuid = cellData.applicationUuid;
            const stageId = cellData.stageId;

            store.commit("assignHrdcData", {
              applicationUuid,
              stageId,
              firstNameAccEnrollment: cellData.firstNameAccEnrollment,
              lastNameAccEnrollment: cellData.lastNameAccEnrollment,
              contactNoAccEnrollment: cellData.contactNoAccEnrollment,
              emailAccEnrollment: cellData.emailAccEnrollment,
              viewId,
            });

            this.$router.push({
              name: opt.value,
              query: {
                currentPageNo: this.currentPageNo,
                _ausk: applicationUuid,
                // Carry the current view so "back" returns to the same view.
                viewId,
              },
            });
          },
        }));
      },
    });

    this.rolesAssignation(this.auth.roles);
  },
  mounted() {
    const viewId = this.$route.query.viewId;

    if (viewId !== "all" && viewId !== "trashed") {
      this.getAllViews(parseInt(viewId, 10));
    } else {
      this.getAllViews(viewId);
    }

  },
  methods: {
    getConditions() {
      return this.conditions;
    },
    setConditions(conditions) {
      this.selectedFilterConditions = conditions;
      this.conditions = conditions;
      this.$refs.tabulatorDataTable.getFilterCondition(conditions);
    },
    apiGetBrowseUrl() {
      // Check if user have salesperson role, then assign only this salesperson can see back own sales.
      let browseUrl = `${this.$service[this.service.key]}/v1/en/console/${
        this.model.key
      }?hrdcType=${this.hrdcType}`;

      return browseUrl;
    },
    apiGetBrowseTrashUrl() {
      let browseDeleteUrl = `
        ${this.$service[this.service.key]}/v1/en/console/${
        this.model.key
      }?deleted=true
      `;

      if (this.isSalespersonRoles && this.auth.roles.length == 1) {
        browseDeleteUrl = browseDeleteUrl + `&email=${this.auth.email}`;
      }

      return browseDeleteUrl;
    },
    setFiltersViaConditions(conditions) {
      this.$refs.filter.setFiltersViaConditions(conditions);
    },
    getCurrentPageSize(pagesize) {
      this.displayRowCount = pagesize;
    },
    getCurrentSort(sorters) {
      this.cColumnSort = sorters;
      this.cColumnSort = sorters.map((sorter) => {
        return {
          column: sorter.field,
          dir: sorter.dir,
        };
      });
    },

    getCurrentColumnWidth(resizedColumns) {
      const resizedColumnField = resizedColumns.getField();
      const resizedColumnWidth = resizedColumns.getWidth();

      //set the resized column width and filed name to the array
      const resizedColumnWidthAndField = {
        field: resizedColumnField,
        width: resizedColumnWidth,
      };

      const index = this.allResizeColumns.findIndex((item) => {
        return item.field === resizedColumnField;
      });

      if (index !== -1) {
        this.allResizeColumns[index].width = resizedColumnWidth;
      } else {
        this.allResizeColumns.push(resizedColumnWidthAndField);
      }
    },
    changeTableDetails(listAllViews, viewId) {
      // get the view details from listAllViews where id is equal to viewId
      if (viewId == "trashed") {
        //this.$refs.tabulatorDataTable.clearTableData();
        this.$refs.tabulatorDataTable.callApiUrl(this.apiGetBrowseTrashUrl());
        this.$refs.selectColumn.showAllColumns([]);
        this.$refs.tabulatorDataTable.callSavedHeaderWidth([
          {
            field: "company",
            width: 300,
          },
        ]);
        this.$refs.search.getFilterCondition([]); /// add this one
        this.$refs.customView.changeSelectedTabStatus("trashed", 0);
      } else if (viewId == "all") {
        this.$refs.tabulatorDataTable.callSavedHeaderWidth([
          {
            field: "company",
            width: 300,
          },
        ]);
        this.$refs.selectColumn.showAllColumns([]);
        this.$refs.search.getFilterCondition([]);
        this.$refs.customView.changeSelectedTabStatus("all", 1);
        this.setCurrentPageTo();
      } else {
        const tabIndex =
          listAllViews.indexOf(listAllViews.find((x) => x.id === viewId)) + 2;
        this.$refs.customView.changeSelectedTabStatus(viewId, tabIndex);
        const singleViewDetail = listAllViews.filter((item) => {
          return item.id === viewId;
        });

        if (singleViewDetail.length > 0) {
          if (
            JSON.parse(singleViewDetail[0].manageColumnCustomWidth).length > 0
          ) {
            this.$refs.tabulatorDataTable.callSavedHeaderWidth(
              JSON.parse(singleViewDetail[0].manageColumnCustomWidth)
            );
          }

          this.$refs.selectColumn.showViewSelectedColumns(
            JSON.parse(singleViewDetail[0].cColumnCondition)
          );

          // calling API
          if (JSON.parse(singleViewDetail[0].filterCondition).length > 0) {
            this.$refs.filter.setFiltersViaConditions(
              JSON.parse(singleViewDetail[0].filterCondition)
            );
          }

          // calling API
          if (JSON.parse(singleViewDetail[0].cColumnSort).length > 0) {
            this.$refs.tabulatorDataTable.callSavedColumnSort(
              JSON.parse(singleViewDetail[0].cColumnSort)
            );
          }

          // calling API
          if (singleViewDetail[0].displayRowCount != this.paginationSize) {
            this.$refs.tabulatorDataTable.callSavedPageSize(
              singleViewDetail[0].displayRowCount
            );
          }
          // add following one
          this.$refs.search.getFilterCondition(
            JSON.parse(singleViewDetail[0].filterCondition)
          );
        }

        this.setCurrentPageTo();
      }
    },
    getAllViews(viewId) {
      this.api.setMethod(`GET`);
      this.api.setUrl(
        `${this.$service.hrdc}/v1/en/console/crmView/list?modelKey=${this.model.key}`
      );
      this.api.setCallbackCompleted((response) => {
        // get all private views when the ouwnerUuid is equal to auth.uuid
        const privateViews = response.filter((view) => {
          return view.isPrivate === true && view.ownerUuid === this.auth.uuid;
        });

        // get all public views
        const publicViews = response.filter((view) => {
          return view.isPrivate === false;
        });

        // Assign public views to state.
        this.$store.commit("assignPublicViews", publicViews);

        // push all private and public views to listAllViews
        this.listAllViews = [...publicViews, ...privateViews];
        this.changeTableDetails(this.listAllViews, viewId);
      });
      // Safety net: the table's initial auto-load is deferred (deferInitialLoad)
      // and is only released once a view is applied above. If the view list
      // fails to load, release it explicitly so the table isn't stuck loading.
      this.api.setCallbackError(() => {
        if (this.$refs.tabulatorDataTable) {
          this.$refs.tabulatorDataTable.releaseDeferredLoad();
        }
      });
      this.api.fetch();
    },
    applyColumnSelection(selectedColumns) {
      this.selectedCustomColums = selectedColumns;
      this.$refs.tabulatorDataTable.applyColumnSelection(selectedColumns);
    },
    getCurrentPageNumber(pageno) {
      this.currentPageNo = pageno;
    },
    setCurrentPageTo() {
      var pageNo =
        this.$store.state.developer.data.paginationPageNo != null
          ? this.$store.state.developer.data.paginationPageNo
          : 1;
      this.$refs.tabulatorDataTable.tabulator.setPage(pageNo);
    },
    nextFormRedirect(stageId, paymentChannel) {
      let route = null;
      switch (stageId) {
        case this.hrdcData.stagePriority.applicationSubmitted:
          route = "ViewHrdcApplication";
          break;

        case this.hrdcData.stagePriority.applicationApproved:
          route = "SendHrdcEmailToClient";
          break;

        case this.hrdcData.stagePriority.sentConfirmationEmailToClient:
        case this.hrdcData.stagePriority.clientRevertFormIncomplete:
        case this.hrdcData.stagePriority.grantApproved:
        case this.hrdcData.stagePriority.formsCompleted:
          route = "ClientRevertForm";
          break;

        case this.hrdcData.stagePriority.clientRevertT3Form:
          route = "ManualInvoiceToHrdc";
          break;

        case this.hrdcData.stagePriority.manualInvoiceToHrdc:
          route = "ClaimSubmitToHrdc";
          break;

        case this.hrdcData.stagePriority.submittedClaimToHrdc:
          route = "ClaimApprovedFromHrdc";
          break;

        case this.hrdcData.stagePriority.claimApprovedFromHrdc:
          route = "PaymentReceivedFromHrdc";
          break;

        case this.hrdcData.stagePriority.paymentReceivedFromHrdc:
          if (paymentChannel == 2) {
            route = "EnrollmentDetail";
          }
          break;

        case this.hrdcData.stagePriority.creditNoteRequested:
          route = "CreditNoteDocumented";
          break;

        case this.hrdcData.stagePriority.creditNoteDocumented:
        case this.hrdcData.stagePriority.creditNoteGenerated:
          route = "RefundEmailSubmission";
          break;

        case this.hrdcData.stagePriority.refundEmailSubmission:
          route = "RefundEmailApproval1";
          break;

        case this.hrdcData.stagePriority.refundEmailApproval1:
          route = "RefundEmailApproval2";
          break;

        case this.hrdcData.stagePriority.refundEmailApproval2:
        case this.hrdcData.stagePriority.refundEmailApToCimbRejected:
          route = "RefundEmailArToAp";
          break;

        case this.hrdcData.stagePriority.refundEmailArToAp:
          route = "RefundEmailApToCimb";
          break;

        case this.hrdcData.stagePriority.apSubmitRefundToCimb:
          route = "EmailPaymentAdviceToClient";
          break;

        default:
          route = "ViewHrdcApplication";
          break;
      }

      return route;
    },
    flagCol(flagVal) {
      if (flagVal) {
        return `<span class="tbl-flag tbl-flag--active normal-flag"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path fill-rule="evenodd" d="M3 2.25a.75.75 0 0 1 .75.75v.54l1.838-.46a9.75 9.75 0 0 1 6.725.738l.108.054a8.25 8.25 0 0 0 5.58.652l.96-.24a.75.75 0 0 1 .921.727v8.769a.75.75 0 0 1-.53.719l-.96.24a9.75 9.75 0 0 1-6.59-.77l-.108-.053a8.25 8.25 0 0 0-5.69-.625l-1.454.364V21a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75Z" clip-rule="evenodd" /></svg></span>`;
      } else {
        return `<span class="tbl-flag normal-flag"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="18" height="18"><path stroke-linecap="round" stroke-linejoin="round" d="M3 3v1.5M3 21v-6m0 0 2.77-.693a9 9 0 0 1 6.208.682l.108.054a9 9 0 0 0 6.086.71l3.114-.732a48.524 48.524 0 0 1-.005-10.499l-3.11.732a9 9 0 0 1-6.085-.711l-.108-.054a9 9 0 0 0-6.208-.682L3 4.5M3 15V4.5" /></svg></span>`;
      }
    },
    clearErrorMsg() {
      for (let error in this.errorField) {
        this.errorField[error] = null;
      }
    },
    showErrorMessage(response) {
      for (const key in response.data) {
        this.errorField[key] = null;
        this.errorField[key] = response.data[key];
      }
    },
    updateFlagRemarkOnly() {
      const cell = this.flagDetails;
      const applicationUuid = cell.getValue();

      this.api.setMethod("POST");
      this.api.setUrl(
        `${
          this.$service[this.service.key]
        }/v1/en/console/application/update-flag-remark-only`
      );
      this.api.setParams({
        applicationUuid,
        flagRemarks: this.flagRemarks,
      });
      this.api.setCallbackCompleted((response) => {
        const { status, message } = response;

        if (status) {
          this.$store.dispatch("showMessage", {
            message,
            messageType: "success",
            timeout: 2000,
          });

          this.$set(cell.getData(), "flagRemarks", this.flagRemarks);

          this.flagDialog = !this.flagDialog;
          this.clearErrorMsg();
        }

        if (!status) {
          this.showErrorMessage(response);
        }
      });
      this.api.fetch();
    },
    updateFlagAndRemark() {
      const cell = this.flagDetails;
      const data = cell.getData();
      const applicationUuid = cell.getValue();
      const flagVal = data.isFlag;

      this.api.setMethod("POST");
      this.api.setUrl(
        `${
          this.$service[this.service.key]
        }/v1/en/console/application/update-flag-status`
      );
      this.api.setParams({
        userUuid: this.auth.uuid, // Need to record who flag the case.
        applicationUuid,
        flagVal,
        flagRemarks: this.flagRemarks, // Add the remarks.
      });
      this.api.setCallbackCompleted((response) => {
        try {
          const { status, message } = response;
          if (status) {
            // Mutate the row and let Vue re-render. BreadDataTableCell
            // deep-watches its row, so both the Flag cell and the index-column
            // flag badge re-derive from data. This replaces ~30 lines of DOM
            // surgery (replaceWith on the cell, querySelector(".number-class")
            // on the row) that depended on Tabulator owning the DOM.
            const rowData = cell.getData();
            this.$set(rowData, "isFlag", !flagVal);
            this.$set(rowData, "flagRemarks", this.flagRemarks);

            this.$store.dispatch("showMessage", {
              message,
              messageType: "success",
            });

            this.flagDialog = !this.flagDialog;
            this.clearErrorMsg();
          }

          if (!status) {
            this.showErrorMessage(response);
          }
        } catch (err) {
          console.log(err);
        }
      });
      this.api.fetch();
    },
    closeUpdateFlagAndRemarkDialog() {
      this.flagDialog = !this.flagDialog;
      this.flagRemarks = null;
      this.clearErrorMsg();
    },
    downloadData(fileType, rowsType) {
      this.isLoading = true;

      switch (fileType) {
        case "csv":
          this.downloadCsvData(rowsType);
          break;
        case "xlsx":
          this.downloadExcelData(rowsType);
          break;
        case "pdf":
          this.downloadPdfData(rowsType);
          break;
        default:
          break;
      }
    },
    downloadCsvData(rowsType) {
      this.$refs.tabulatorDataTable.tabulator.download(
        "csv",
        `${this.model.key}.csv`,
        {
          sheetName: `${this.model.key}`,
        },
        rowsType == "selected" ? "selected" : "all"
      );
      this.isLoading = false;
      // unchecked all the selected rows
      this.$refs.tabulatorDataTable.tabulator.deselectRow();
    },
    downloadExcelData(rowsType) {
      this.$refs.tabulatorDataTable.tabulator.download(
        "xlsx",
        `${this.model.key}.xlsx`,
        {
          sheetName: `${this.model.key}`,
        },
        rowsType == "selected" ? "selected" : "all"
      );
      this.isLoading = false;
      this.$refs.tabulatorDataTable.tabulator.deselectRow();
    },
    downloadPdfData(rowsType) {
      this.$refs.tabulatorDataTable.tabulator.download(
        "pdf",
        `${this.model.key}.pdf`,
        {
          orientation: "portrait", //set page orientation to portrait
          title: "Demo Product Details", //add title to report
          autoTable: {},
        },
        rowsType == "selected" ? "selected" : "all"
      );
      this.isLoading = false;
      this.$refs.tabulatorDataTable.tabulator.deselectRow();
    },
  },
};
</script>

<style scoped>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .page-toolbar__title {
  color: var(--app-text);
}

.dark-mode .page-toolbar__count {
  color: var(--app-text-faint);
}

.dark-mode .filter-bar__toggle {
  color: var(--app-text);
  background: var(--app-surface);
  border: 1px solid var(--app-border);
}

.dark-mode .filter-bar__toggle:hover {
  background: var(--app-elevated);
  border-color: var(--app-border-strong);
}

.dark-mode .filter-panel {
  background: var(--app-card);
  border: 1px solid var(--app-border);
}

.dark-mode .filter-panel__columns {
  background: var(--app-surface);
  border-top: 1px solid var(--app-border);
}

.dark-mode .filter-panel__columns >>> .tb-select-column-dropdown .v-input__slot {
  border: 1px solid var(--app-border) !important;
}

.dark-mode .filter-panel__columns >>> .tb-select-column-dropdown .v-input__slot:hover {
  border-color: var(--app-border-strong) !important;
}

.dark-mode .filter-panel__columns >>> .tb-select-column-dropdown .v-input__control > .v-input__slot {
  border: 1px solid var(--app-border) !important;
  background: var(--app-card) !important;
}

.dark-mode .filter-panel__columns >>> .tb-select-column-dropdown .v-select__selection {
  color: var(--app-text) !important;
}

.dark-mode .filter-panel__columns >>> .tb-select-column-dropdown .v-chip {
  background: var(--app-accent-soft) !important;
}

.dark-mode .filter-panel__columns >>> .tb-select-column-dropdown .grey--text {
  color: var(--app-text-muted) !important;
}

.dark-mode .filter-panel__columns >>> .tb-select-column-dropdown .v-label {
  color: var(--app-text-faint) !important;
}

.dark-mode .filter-panel__columns >>> .tb-clear-btn {
  color: var(--app-text-muted) !important;
  border: 1px solid var(--app-border) !important;
  background: var(--app-card) !important;
}

.dark-mode .filter-panel__columns >>> .tb-clear-btn:hover {
  background: var(--app-elevated) !important;
  border-color: var(--app-border-strong) !important;
}

.dark-mode .filter-panel >>> .pb-3 {
  background: var(--app-surface);
  border-bottom: 1px solid var(--app-border);
}

.dark-mode .filter-panel >>> .v-input__slot {
  background: var(--app-card) !important;
  border: 1px solid var(--app-border) !important;
}

.dark-mode .filter-panel >>> .v-input__slot:hover {
  border-color: var(--app-border-strong) !important;
}

.dark-mode .filter-panel >>> .v-select__selection {
  color: var(--app-text) !important;
}

.dark-mode .filter-panel >>> .v-label {
  color: var(--app-text-faint) !important;
}

.dark-mode .filter-panel >>> .tb-btn-clear {
  border: 1px solid var(--app-border) !important;
  background: var(--app-card) !important;
  color: var(--app-text-muted) !important;
}

.dark-mode .filter-panel >>> .tb-btn-clear:hover {
  background: var(--app-surface) !important;
  border-color: var(--app-border-strong) !important;
}

.dark-mode .filter-panel >>> .tb-filter-applied h4 {
  color: var(--app-text-muted);
}

.dark-mode .filter-panel >>> .v-chip {
  background: var(--app-warning-bg) !important;
}

.dark-mode .filter-panel >>> .with-border .v-input__slot {
  border: 1px solid var(--app-border) !important;
}

.dark-mode .rv-dialog__card {
  background: var(--app-card);
}

.dark-mode .rv-dialog__error {
  background: var(--app-danger-bg);
}

.dark-mode .rv-dialog__hint {
  color: var(--app-text-faint);
}

.dark-mode .rv-dialog__btn--cancel {
  background: var(--app-card);
  color: var(--app-text-muted);
  border: 1.5px solid var(--app-border-strong);
}

.dark-mode .rv-dialog__btn--cancel:hover {
  background: var(--app-surface);
  border-color: var(--app-border-strong);
}

.dark-mode .rv-dialog__btn--secondary {
  background: var(--app-accent-soft);
}

.dark-mode .rv-textarea >>> .v-input__slot {
  background: var(--app-card) !important;
  border: 1px solid var(--app-border) !important;
}

/* >>> end auto-dark <<< */

/* The floating glass sheet is NOT declared here any more — it is one rule in
   src/plugins/theme-glass.css (§2) that covers every routed page's root
   v-container, including this one, and it neutralises the v-card wrapper too.
   Keeping a copy here would mean two competing definitions of the same surface;
   the glass layer's `#app .layout-main__content > .container` is (1,2,0) and
   would win anyway, so the copy would have been dead code that still read as
   though it were in effect. */
.rv-page {
  /* Fills main minus the breadcrumb and footer; a `100vh - 64px` guess only
     subtracts the app bar and overflows. See .layout-main__content. */
  flex: 1 0 auto;
  font-family: 'Lato', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
}

.rv-card-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* Page toolbar */
.page-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 16px 12px;
  flex-wrap: wrap;
  gap: 12px;
}

.page-toolbar__left {
  display: flex;
  align-items: baseline;
  gap: 12px;
  min-width: 0;
}

.page-toolbar__title {
  font-family: 'Lato', sans-serif;
  font-size: 1.2rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  letter-spacing: -0.2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.page-toolbar__count {
  font-family: 'Lato', sans-serif;
  font-size: 0.75rem;
  font-weight: 600;
  color: #94a3b8;
  white-space: nowrap;
}

.page-toolbar__right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.page-search {
  padding: 0 16px 16px;
}

/* Filter bar */
.filter-bar {
  padding: 0 16px 12px;
}

.filter-bar__toggle {
  display: inline-flex;
  align-items: center;
  padding: 7px 14px;
  border-radius: 8px;
  font-family: 'Lato', sans-serif;
  font-size: 0.82rem;
  font-weight: 600;
  color: #334155;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.15s ease;
}

.filter-bar__toggle:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
}

.filter-bar__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 10px;
  background: #0ea5e9;
  color: #fff;
  font-size: 0.68rem;
  font-weight: 700;
  margin-left: 6px;
}

/* Filter panel */
.filter-panel {
  margin: 0 16px 14px;
  padding: 0;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
}

.filter-panel__divider {
  display: none;
}

.filter-panel__columns {
  background: #f8fafc;
  padding: 12px 16px;
  border-top: 1px solid #e2e8f0;
}

/* Override BreadTabulatorSelectColumn styles */
.filter-panel__columns >>> .tb-right-section {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.filter-panel__columns >>> .tb-show-column {
  display: none !important;
}

.filter-panel__columns >>> .tb-select-column-dropdown {
  flex: 1;
  min-width: 200px;
}

.filter-panel__columns >>> .tb-select-column-dropdown .v-input {
  margin-top: 0 !important;
  padding-top: 0 !important;
  border: none !important;
  border-radius: 8px !important;
  background: transparent !important;
}

.filter-panel__columns >>> .tb-select-column-dropdown .v-input__slot {
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  min-height: 38px !important;
  box-shadow: none !important;
  padding: 0 8px !important;
}

.filter-panel__columns >>> .tb-select-column-dropdown .v-input__slot::before,
.filter-panel__columns >>> .tb-select-column-dropdown .v-input__slot::after {
  display: none !important;
}

.filter-panel__columns >>> .tb-select-column-dropdown .v-input__slot:hover {
  border-color: #cbd5e1 !important;
}

.filter-panel__columns >>> .tb-select-column-dropdown .v-input__control {
  min-height: 38px !important;
}

.filter-panel__columns >>> .tb-select-column-dropdown .v-input__control > .v-input__slot {
  box-shadow: none !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  background: #fff !important;
}

.filter-panel__columns >>> .tb-select-column-dropdown .v-text-field__details {
  display: none !important;
}

.filter-panel__columns >>> .tb-select-column-dropdown .v-text-field--enclosed .v-input__prepend-outer,
.filter-panel__columns >>> .tb-select-column-dropdown .v-text-field--enclosed .v-input__append-outer {
  margin-top: 0 !important;
}

.filter-panel__columns >>> .tb-select-column-dropdown .v-text-field--solo .v-input__control {
  border-radius: 8px !important;
}

.filter-panel__columns >>> .tb-select-column-dropdown .v-text-field--solo > .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

.filter-panel__columns >>> .tb-select-column-dropdown .v-select__selection {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.78rem !important;
  font-weight: 600 !important;
  color: #334155 !important;
}

.filter-panel__columns >>> .tb-select-column-dropdown .v-chip {
  background: #e0f2fe !important;
  color: #0369a1 !important;
  border-radius: 6px !important;
  font-family: 'Lato', sans-serif !important;
  font-size: 0.72rem !important;
  font-weight: 600 !important;
  height: 24px !important;
}

.filter-panel__columns >>> .tb-select-column-dropdown .grey--text {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.72rem !important;
  font-weight: 600 !important;
  color: #64748b !important;
}

.filter-panel__columns >>> .tb-select-column-dropdown .v-label {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.82rem !important;
  color: #94a3b8 !important;
}

.filter-panel__columns >>> .tb-clear-btn {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.78rem !important;
  font-weight: 600 !important;
  color: #64748b !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  padding: 0 14px !important;
  min-width: auto !important;
  height: 38px !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  background: #fff !important;
}

.filter-panel__columns >>> .tb-clear-btn:hover {
  background: #f1f5f9 !important;
  border-color: #cbd5e1 !important;
}

/* Override BreadTabulatorFilterable styles */

/* Add filter row — top section */
.filter-panel >>> .pb-3 {
  background: #f8fafc;
  padding: 14px 16px 14px !important;
  border-bottom: 1px solid #e2e8f0;
}

/* Filter applied row — bottom section */
.filter-panel >>> .row:not(.pb-3) {
  padding: 12px 16px !important;
}

.filter-panel >>> .v-input__slot {
  background: #fff !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  min-height: 36px !important;
  box-shadow: none !important;
}

.filter-panel >>> .v-input__slot::before,
.filter-panel >>> .v-input__slot::after {
  display: none !important;
}

.filter-panel >>> .v-input__slot:hover {
  border-color: #cbd5e1 !important;
}

.filter-panel >>> .v-select__selection,
.filter-panel >>> .v-text-field__slot input,
.filter-panel >>> .v-label {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.82rem !important;
}

.filter-panel >>> .v-select__selection {
  font-weight: 600 !important;
  color: #334155 !important;
}

.filter-panel >>> .v-label {
  color: #94a3b8 !important;
}

.filter-panel >>> .v-text-field__slot input {
  font-weight: 600 !important;
  color: #1a1e24 !important;
}

.filter-panel >>> .tb-btn {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.78rem !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  border-radius: 8px !important;
  min-width: auto !important;
  padding: 0 18px !important;
  height: 36px !important;
  box-shadow: none !important;
  background: #0ea5e9 !important;
  color: #fff !important;
}

.filter-panel >>> .tb-btn:hover {
  background: #0284c7 !important;
}

.filter-panel >>> .tb-btn-clear {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.78rem !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  border-radius: 8px !important;
  min-width: auto !important;
  padding: 0 18px !important;
  height: 36px !important;
  box-shadow: none !important;
  border: 1px solid #e2e8f0 !important;
  background: #fff !important;
  color: #64748b !important;
}

.filter-panel >>> .tb-btn-clear:hover {
  background: #f8fafc !important;
  border-color: #cbd5e1 !important;
}

.filter-panel >>> .tb-filter-applied {
  display: flex;
  align-items: center;
}

.filter-panel >>> .tb-filter-applied h4 {
  font-family: 'Lato', sans-serif;
  font-size: 0.75rem;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0;
  white-space: nowrap;
}

.filter-panel >>> .v-chip {
  border-radius: 6px !important;
  font-family: 'Lato', sans-serif !important;
  font-size: 0.72rem !important;
  font-weight: 600 !important;
  background: #fef3c7 !important;
  color: #92400e !important;
}

.filter-panel >>> .with-border .v-input__slot {
  border: 1px solid #e2e8f0 !important;
}

/* Dialog styles */
.rv-dialog__card {
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
}

.rv-dialog__header {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background: linear-gradient(135deg, #0ea5e9, #38bdf8);
}

.rv-dialog__title {
  font-family: 'Lato', sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  color: #fff;
}

.rv-dialog__close {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  border: none;
  background: rgba(255, 255, 255, 0.15);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
}

.rv-dialog__close:hover {
  background: rgba(255, 255, 255, 0.3);
}

.rv-dialog__body {
  padding: 22px 24px;
}

.rv-dialog__error {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 10px;
  margin-bottom: 14px;
  font-size: 0.82rem;
  font-weight: 600;
  color: #dc2626;
}

.rv-dialog__label {
  display: block;
  font-family: 'Lato', sans-serif;
  font-size: 0.78rem;
  font-weight: 700;
  color: #2d3239;
  margin-bottom: 6px;
}

.rv-dialog__hint {
  display: flex;
  align-items: center;
  font-size: 0.72rem;
  color: #94a3b8;
  margin-top: 6px;
}

.rv-dialog__actions {
  display: flex;
  gap: 10px;
  padding: 0 24px 20px;
}

.rv-dialog__btn {
  padding: 10px 20px;
  border-radius: 10px;
  font-size: 0.85rem;
  font-weight: 600;
  font-family: 'Lato', sans-serif;
  cursor: pointer;
  transition: all 0.15s ease;
  border: none;
}

.rv-dialog__btn--cancel {
  background: #fff;
  color: #64748b;
  border: 1.5px solid #d1d5db;
}

.rv-dialog__btn--cancel:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}

.rv-dialog__btn--confirm {
  background: #56bde8;
  color: #fff;
  flex: 1;
}

.rv-dialog__btn--confirm:hover {
  background: #3dadd8;
  box-shadow: 0 4px 12px rgba(86, 189, 232, 0.3);
}

.rv-dialog__btn--secondary {
  background: #dbeafe;
  color: #1d4ed8;
}

.rv-dialog__btn--secondary:hover {
  background: #bfdbfe;
}

/* Textarea override */
.rv-textarea >>> .v-input__slot {
  background: #fff !important;
  border: 1px solid #e2e4e8 !important;
  border-radius: 10px !important;
  box-shadow: none !important;
}

.rv-textarea >>> .v-input__slot::before,
.rv-textarea >>> .v-input__slot::after {
  display: none !important;
}

.rv-textarea >>> .v-input__slot:hover {
  border-color: #c9cdd3 !important;
}

.rv-textarea >>> textarea {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.85rem !important;
  font-weight: 600 !important;
  color: #1a1e24 !important;
}

/* Responsive */
@media (max-width: 959px) {
  .page-toolbar {
    padding: 16px 12px 10px;
  }

  .page-toolbar__title {
    font-size: 1rem;
  }

  .page-toolbar__left {
    flex-direction: column;
    gap: 4px;
  }

  .page-search {
    padding: 0 12px 12px;
  }

  .filter-bar {
    padding: 0 12px 10px;
    flex-direction: column;
    align-items: stretch !important;
  }

  .filter-panel__columns >>> .tb-select-column-dropdown {
    min-width: 0;
    width: 100%;
  }

  .filter-panel {
    margin: 0 12px 10px;
    padding: 12px;
  }

  .filter-panel >>> .row {
    flex-direction: column;
  }

  .filter-panel >>> .col-md-4,
  .filter-panel >>> .col-md-3,
  .filter-panel >>> .col-md-2,
  .filter-panel >>> .col-md-9,
  .filter-panel >>> .col-md-1 {
    max-width: 100% !important;
    flex: 0 0 100% !important;
    padding: 2px 0 !important;
  }
}

@media (max-width: 599px) {

  /* Toolbar */
  .page-toolbar {
    padding: 12px 10px 8px !important;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .page-toolbar__title {
    font-size: 0.95rem !important;
  }

  .page-toolbar__right {
    width: 100%;
    justify-content: flex-end;
  }

  /* Filter bar */
  .filter-bar {
    padding: 0 10px 8px !important;
  }

  .filter-bar__toggle {
    font-size: 0.78rem !important;
    padding: 6px 12px !important;
  }

  /* Filter panel */
  .filter-panel {
    margin: 0 10px 8px !important;
    padding: 10px !important;
  }

  /* Search */
  .page-search {
    padding: 0 10px 10px !important;
  }

  /* Dialog card */
  .flag-dialog-body {
    padding: 20px 16px !important;
  }
}

/* New Application Button */
.new-app-btn {
  display: inline-flex;
  align-items: center;
  padding: 8px 18px;
  border-radius: 10px;
  border: none;
  background: #0ea5e9;
  color: #fff;
  font-family: 'Lato', sans-serif;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
  margin-right: 8px;
}

.new-app-btn:hover {
  background: #0284c7;
  box-shadow: 0 4px 12px rgba(14, 165, 233, 0.3);
}

/* >>> dark companions: the light rules above pin these to a dark ink
   with !important, which on the dark field renders the text invisible
   rather than absent. Token references only. <<< */

.dark-mode .filter-panel >>> .v-text-field__slot input {
  color: var(--app-text) !important;
}

.dark-mode .rv-textarea >>> textarea {
  color: var(--app-text) !important;
}
</style>

<style>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .rv-page .tb-view-area {
  background: var(--app-surface);
  border: 1px solid var(--app-border);
}

.dark-mode .rv-page .tb-view-area .v-tab {
  color: var(--app-text-muted) !important;
}

.dark-mode .rv-page .tb-view-area .v-tab:hover {
  color: var(--app-text) !important;
  background: var(--app-elevated) !important;
}

.dark-mode .rv-page .tb-view-area .v-tab--active {
  background: var(--app-card) !important;
}

.dark-mode .rv-page .tb-view-area > .col-md-10 > .v-btn {
  background: var(--app-card) !important;
  border-right: 1px solid var(--app-border) !important;
}

.dark-mode .rv-page .tb-view-area > .col-md-10 > .v-btn .v-icon {
  color: var(--app-text-muted) !important;
}

.dark-mode .rv-page .tb-view-area > .col-md-10 > .v-btn:hover {
  background: var(--app-elevated) !important;
}

.dark-mode .rv-page .tb-view-area .v-slide-group__prev .v-icon,
.dark-mode .rv-page .tb-view-area .v-slide-group__next .v-icon {
  color: var(--app-text-muted) !important;
}

.dark-mode .rv-page .tb-view-area .tb-view-dropdown-btn .mdi-chevron-down {
  color: var(--app-text-faint) !important;
}

.dark-mode .filter-panel__columns .tb-select-column-dropdown .v-input__slot {
  border: 1px solid var(--app-border) !important;
}

.dark-mode .rv-page .page-toolbar__right .v-btn-toggle .v-btn--tile {
  border: 1px solid var(--app-border) !important;
  color: var(--app-text) !important;
  background: var(--app-card) !important;
}

.dark-mode .rv-page .page-toolbar__right .v-btn-toggle .v-btn--tile:hover {
  background: var(--app-surface) !important;
  border-color: var(--app-border-strong) !important;
}

.dark-mode .rv-page .page-toolbar__right .v-btn-toggle .v-btn--tile .v-icon {
  color: var(--app-text-muted) !important;
}

.dark-mode .rv-page .col-md-2 .v-btn--tile.v-btn--outlined {
  border: 1px solid var(--app-border) !important;
  color: var(--app-text) !important;
  background: var(--app-card) !important;
}

.dark-mode .rv-page .col-md-2 .v-btn--tile.v-btn--outlined:hover {
  background: var(--app-surface) !important;
  border-color: var(--app-border-strong) !important;
}

.dark-mode .rv-page .col-md-2 .v-btn--tile.v-btn--outlined.v-btn--disabled {
  color: var(--app-text-faint) !important;
}

/* The unscoped `.v-menu__content …` block that used to sit here is gone.
   It was global — unscoped CSS is injected once and never removed, so a rule
   written for THIS page's dropdown repainted every menu in the app (with
   !important, and with hard-coded light hex) for the rest of the session. That
   is what made the same v-select look different depending on which page you had
   visited. Menus are defined ONCE, in tokens, in src/plugins/theme-glass.css §3
   — panel, list, item radius, hover, active, typography and the state overlay.
   A page that genuinely needs its own menu styling should give that v-menu a
   `content-class` and key off it, the way .bdt-menu and .tb-view-menu do. */

.dark-mode .tbl-flag {
  border: 1px solid var(--app-border);
  background: var(--app-card);
}

.dark-mode .tbl-flag .v-icon {
  color: var(--app-text-faint) !important;
}

.dark-mode .tbl-flag:hover {
  background: var(--app-elevated);
}

.dark-mode .tbl-flag:hover .v-icon {
  color: var(--app-text-faint) !important;
}

.dark-mode .tbl-next-btn {
  border: 1px solid var(--app-border);
  background: var(--app-card);
}

.dark-mode .tbl-next-btn:hover {
  background: var(--app-accent-soft);
}

.dark-mode .tbl-next-btn .v-icon {
  color: var(--app-text-muted) !important;
}

.dark-mode .tabulator .tabulator-row .tabulator-cell input[type="checkbox"],
.dark-mode .tabulator .tabulator-header .tabulator-col input[type="checkbox"] {
  border: 2px solid var(--app-border-strong);
  background: var(--app-card);
}

.dark-mode .tabulator .tabulator-row .tabulator-cell input[type="checkbox"]:hover,
.dark-mode .tabulator .tabulator-header .tabulator-col input[type="checkbox"]:hover {
  border-color: var(--app-border-strong);
}

.dark-mode .tabulator .tabulator-row .tabulator-cell input[type="checkbox"]:checked::after,
.dark-mode .tabulator .tabulator-header .tabulator-col input[type="checkbox"]:checked::after {
  border: solid var(--app-card);
}

.dark-mode .custom-pagesize__trigger {
  color: var(--app-text);
  background: var(--app-card);
  border: 1px solid var(--app-border);
}

.dark-mode .custom-pagesize__trigger:hover {
  border-color: var(--app-border-strong);
}

.dark-mode .custom-pagesize__menu {
  background: var(--app-card);
  border: 1px solid var(--app-border);
}

.dark-mode .custom-pagesize__item {
  color: var(--app-text);
}

.dark-mode .custom-pagesize__item:hover {
  background: var(--app-accent-soft);
}

.dark-mode .custom-pagesize__item--active {
  background: var(--app-accent-soft);
}

.dark-mode .tabulator {
  border: 1px solid var(--app-border) !important;
}

.dark-mode .tabulator .tabulator-header {
  background-color: var(--app-surface) !important;
  border-bottom: 2px solid var(--app-border) !important;
}

.dark-mode .tabulator .tabulator-header .tabulator-col {
  background-color: var(--app-surface) !important;
  border-right: 1px solid var(--app-border) !important;
}

.dark-mode .tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-col-title {
  color: var(--app-text-muted) !important;
}

.dark-mode .tabulator .tabulator-tableholder .tabulator-table .tabulator-row {
  border-bottom: 1px solid var(--app-border) !important;
}

.dark-mode .tabulator .tabulator-tableholder .tabulator-table .tabulator-row:hover {
  background-color: var(--app-surface) !important;
}

.dark-mode .tabulator .tabulator-tableholder .tabulator-table .tabulator-row.tabulator-selected:hover {
  background-color: var(--app-accent-soft) !important;
}

.dark-mode .tabulator .tabulator-tableholder .tabulator-table .tabulator-row .tabulator-cell {
  color: var(--app-text) !important;
  border-right: 1px solid var(--app-border) !important;
}

.dark-mode .tabulator .tabulator-footer {
  background-color: var(--app-surface) !important;
  border-top: 1px solid var(--app-border) !important;
}

.dark-mode .tabulator .tabulator-footer .tabulator-page-counter {
  color: var(--app-text-muted) !important;
}

.dark-mode .tabulator .tabulator-footer .tabulator-paginator label {
  color: var(--app-text-muted) !important;
}

.dark-mode .tabulator .tabulator-footer .tabulator-page-size {
  color: var(--app-text) !important;
  background: var(--app-card) !important;
  border: 1px solid var(--app-border) !important;
}

.dark-mode .tabulator .tabulator-footer .tabulator-page-size:hover {
  border-color: var(--app-border-strong) !important;
}

.dark-mode .tabulator .tabulator-footer .tabulator-page {
  color: var(--app-text-muted) !important;
  background: var(--app-card) !important;
  border: 1px solid var(--app-border) !important;
}

.dark-mode .tabulator .tabulator-footer .tabulator-page:hover:not(.disabled):not([disabled]) {
  background: var(--app-accent-soft) !important;
}

.dark-mode .tbl-stage-alert--success {
  background: var(--app-success-bg);
}

.dark-mode .tbl-stage-alert--error {
  background: var(--app-danger-bg);
}

.dark-mode .tbl-stage-alert--warning {
  background: var(--app-warning-bg);
}

/* >>> end auto-dark <<< */

/* Dialog rounded override */
.rv-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important;
}

/* View tabs bar override */
.rv-page .tb-view-area {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-bottom: none;
  border-radius: 10px 10px 0 0;
  margin: 0;
  align-items: center;
}

.rv-page .tb-view-area .v-tabs {
  background: transparent !important;
}

.rv-page .tb-view-area .v-tab {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.78rem !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  color: #64748b !important;
  min-width: auto !important;
  padding: 0 14px !important;
}

.rv-page .tb-view-area .v-tab:hover {
  color: #334155 !important;
  background: #f1f5f9 !important;
}

.rv-page .tb-view-area .v-tab--active {
  color: #0369a1 !important;
  background: #fff !important;
}

.rv-page .tb-view-area .v-tabs-slider-wrapper {
  color: #0ea5e9 !important;
}

/* List menu button in tabs */
.rv-page .tb-view-area > .col-md-10 > .v-btn {
  background: #fff !important;
  border: none !important;
  border-right: 1px solid #e2e8f0 !important;
  box-shadow: none !important;
  min-width: 40px !important;
  width: 40px !important;
  padding: 0 !important;
  border-radius: 10px 0 0 0 !important;
}

.rv-page .tb-view-area > .col-md-10 > .v-btn .v-icon {
  color: #64748b !important;
  font-size: 20px !important;
}

.rv-page .tb-view-area > .col-md-10 > .v-btn:hover {
  background: #f1f5f9 !important;
}

/* Tab arrows */
.rv-page .tb-view-area .v-slide-group__prev,
.rv-page .tb-view-area .v-slide-group__next {
  min-width: 28px !important;
}

.rv-page .tb-view-area .v-slide-group__prev .v-icon,
.rv-page .tb-view-area .v-slide-group__next .v-icon {
  color: #64748b !important;
}

/* Tab dropdown chevron buttons */
.rv-page .tb-view-area .tb-view-dropdown-btn .v-btn {
  min-width: auto !important;
  width: 20px !important;
  height: 20px !important;
  padding: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
}

.rv-page .tb-view-area .tb-view-dropdown-btn .mdi-chevron-down {
  font-size: 16px !important;
  color: #94a3b8 !important;
}

/* Column selector slot background fix */
.filter-panel__columns .tb-select-column-dropdown .v-input__slot {
  background: transparent !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  box-shadow: none !important;
}

/* Export button override */
.rv-page .page-toolbar__right .v-btn-toggle .v-btn--tile {
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  text-transform: none !important;
  font-family: 'Lato', sans-serif !important;
  font-size: 0.82rem !important;
  font-weight: 600 !important;
  letter-spacing: normal !important;
  color: #334155 !important;
  background: #fff !important;
  padding: 0 16px !important;
  height: 36px !important;
  transition: all 0.15s ease;
}

.rv-page .page-toolbar__right .v-btn-toggle .v-btn--tile:hover {
  background: #f8fafc !important;
  border-color: #cbd5e1 !important;
}

.rv-page .page-toolbar__right .v-btn-toggle .v-btn--tile .v-icon {
  color: #64748b !important;
  font-size: 18px !important;
}

.rv-page .page-toolbar__right .v-btn-toggle {
  border-radius: 8px !important;
  box-shadow: none !important;
}

/* BreadTabulatorViewLatest button overrides */
.rv-page .col-md-2 .v-btn--tile.v-btn--outlined {
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  text-transform: none !important;
  font-family: 'Lato', sans-serif !important;
  font-size: 0.78rem !important;
  font-weight: 600 !important;
  letter-spacing: normal !important;
  color: #334155 !important;
  background: #fff !important;
  padding: 0 16px !important;
  height: 34px !important;
  min-width: auto !important;
  margin: 0 3px !important;
  transition: all 0.15s ease;
}

.rv-page .col-md-2 .v-btn--tile.v-btn--outlined:hover {
  background: #f8fafc !important;
  border-color: #cbd5e1 !important;
}

.rv-page .col-md-2 .v-btn--tile.v-btn--outlined.v-btn--disabled {
  opacity: 0.4 !important;
  color: #94a3b8 !important;
}

/* Flag icon styling */
.tbl-flag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
  transition: all 0.15s ease;
}

.tbl-flag .v-icon {
  font-size: 18px !important;
  color: #cbd5e1 !important;
}

.tbl-flag:hover {
  background: #f1f5f9;
}

.tbl-flag:hover .v-icon {
  color: #94a3b8 !important;
}

.tbl-flag--active {
  color: #ef4444 !important;
}

.tbl-flag--active:hover .v-icon {
  color: #dc2626 !important;
}

/* Next action button styling */
.tbl-next-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
  transition: all 0.15s ease;
}

.tbl-next-btn:hover {
  background: #e0f2fe;
  border-color: #0ea5e9;
}

.tbl-next-btn .v-icon {
  font-size: 16px !important;
  color: #64748b !important;
}

.tbl-next-btn:hover .v-icon {
  color: #0369a1 !important;
}

/* Tabulator checkbox styling */
.tabulator .tabulator-row .tabulator-cell input[type="checkbox"],
.tabulator .tabulator-header .tabulator-col input[type="checkbox"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 18px;
  height: 18px;
  border: 2px solid #d1d5db;
  border-radius: 5px;
  background: #fff;
  cursor: pointer;
  transition: all 0.15s ease;
  position: relative;
  margin: 0;
  vertical-align: middle;
}

.tabulator .tabulator-row .tabulator-cell input[type="checkbox"]:hover,
.tabulator .tabulator-header .tabulator-col input[type="checkbox"]:hover {
  border-color: #94a3b8;
}

.tabulator .tabulator-row .tabulator-cell input[type="checkbox"]:checked,
.tabulator .tabulator-header .tabulator-col input[type="checkbox"]:checked {
  background: #0ea5e9;
  border-color: #0ea5e9;
}

.tabulator .tabulator-row .tabulator-cell input[type="checkbox"]:checked::after,
.tabulator .tabulator-header .tabulator-col input[type="checkbox"]:checked::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 5px;
  width: 5px;
  height: 9px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

/* Custom page-size dropdown */
.custom-pagesize {
  position: relative;
  display: inline-block;
  margin-right: 16px;
}

.custom-pagesize__trigger {
  display: inline-flex;
  align-items: center;
  font-family: 'Lato', sans-serif;
  font-size: 0.78rem;
  font-weight: 600;
  color: #334155;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 5px 10px;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
}

.custom-pagesize__trigger:hover {
  border-color: #cbd5e1;
}

.custom-pagesize__menu {
  position: absolute;
  bottom: calc(100% + 6px);
  left: 0;
  min-width: 100%;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 4px;
  z-index: 100;
}

.custom-pagesize__item {
  padding: 6px 12px;
  border-radius: 6px;
  font-family: 'Lato', sans-serif;
  font-size: 0.82rem;
  font-weight: 500;
  color: #334155;
  cursor: pointer;
  transition: background 0.1s ease;
  white-space: nowrap;
}

.custom-pagesize__item:hover {
  background: #f0f9ff;
}

.custom-pagesize__item--active {
  background: #e0f2fe;
  color: #0369a1;
  font-weight: 700;
}

/* Tabulator table border */
.tabulator {
  border: 1px solid #e2e8f0 !important;
  border-top: none !important;
  border-radius: 0 0 10px 10px !important;
}

/* Tabulator deep styling overrides */
.tabulator .tabulator-header {
  background-color: #f8fafc !important;
  border-bottom: 2px solid #e2e8f0 !important;
}

.tabulator .tabulator-header .tabulator-col {
  background-color: #f8fafc !important;
  border-right: 1px solid #e2e8f0 !important;
}

.tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-col-title {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.75rem !important;
  font-weight: 700 !important;
  color: #64748b !important;
  text-transform: uppercase !important;
  letter-spacing: 0.05em !important;
}

.tabulator .tabulator-tableholder .tabulator-table .tabulator-row {
  border-bottom: 1px solid #f1f5f9 !important;
  transition: background-color 0.15s ease;
}

.tabulator .tabulator-tableholder .tabulator-table .tabulator-row:hover {
  background-color: #f8fafc !important;
}

.tabulator .tabulator-tableholder .tabulator-table .tabulator-row.tabulator-selected {
  background-color: #eff8ff !important;
}

.tabulator .tabulator-tableholder .tabulator-table .tabulator-row.tabulator-selected:hover {
  background-color: #e0f2fe !important;
}

.tabulator .tabulator-tableholder .tabulator-table .tabulator-row .tabulator-cell {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.85rem !important;
  color: #334155 !important;
  border-right: 1px solid #f1f5f9 !important;
}

/* Tabulator footer */
.tabulator .tabulator-footer {
  background-color: #f8fafc !important;
  border-top: 1px solid #e2e8f0 !important;
  padding: 12px 20px !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
}

.tabulator .tabulator-footer .tabulator-footer-contents {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;
  gap: 8px;
}

.tabulator .tabulator-footer .tabulator-paginator {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;
  justify-content: flex-end;
}

.tabulator .tabulator-footer .tabulator-page-counter {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.78rem !important;
  font-weight: 600;
  color: #64748b !important;
  margin-right: auto !important;
  white-space: nowrap;
}

.tabulator .tabulator-footer .tabulator-paginator label {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.78rem !important;
  font-weight: 600;
  color: #64748b !important;
  margin-right: 4px;
}

.tabulator .tabulator-footer .tabulator-page-size {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.78rem !important;
  font-weight: 600;
  color: #334155 !important;
  background: #fff !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  padding: 5px 10px !important;
  margin-right: 16px !important;
  outline: none;
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E") !important;
  background-repeat: no-repeat !important;
  background-position: right 8px center !important;
  padding-right: 28px !important;
}

.tabulator .tabulator-footer .tabulator-page-size:hover {
  border-color: #cbd5e1 !important;
}

.tabulator .tabulator-footer .tabulator-page {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.78rem !important;
  font-weight: 600;
  color: #64748b !important;
  background: #fff !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  padding: 5px 10px !important;
  margin: 0 2px !important;
  cursor: pointer;
  transition: all 0.15s ease;
}

.tabulator .tabulator-footer .tabulator-page:hover:not(.disabled):not([disabled]) {
  background: #e0f2fe !important;
  border-color: #0ea5e9 !important;
  color: #0369a1 !important;
}

.tabulator .tabulator-footer .tabulator-page.active {
  background: #0ea5e9 !important;
  border-color: #0ea5e9 !important;
  color: #fff !important;
  font-weight: 700;
}

.tabulator .tabulator-footer .tabulator-page.disabled,
.tabulator .tabulator-footer .tabulator-page[disabled] {
  opacity: 0.4 !important;
  cursor: not-allowed;
}

.tabulator .tabulator-footer .tabulator-pages {
  display: flex;
  align-items: center;
  gap: 2px;
}

/* Tabulator responsive */
@media (max-width: 959px) {
  .tabulator {
    font-size: 0.78rem !important;
  }

  .tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-col-title {
    font-size: 0.68rem !important;
  }

  .tabulator .tabulator-tableholder .tabulator-table .tabulator-row .tabulator-cell {
    font-size: 0.78rem !important;
    padding: 6px 8px !important;
  }

  .tabulator .tabulator-footer {
    padding: 10px 12px !important;
    gap: 6px;
  }

  .tabulator .tabulator-footer .tabulator-paginator {
    flex-wrap: wrap;
    justify-content: center !important;
    gap: 6px;
  }

  .tabulator .tabulator-footer .tabulator-page-counter {
    width: 100%;
    text-align: center;
    margin-right: 0 !important;
    margin-bottom: 4px;
  }

  .tabulator .tabulator-footer .tabulator-page {
    font-size: 0.72rem !important;
    padding: 4px 8px !important;
  }

  .tabulator .tabulator-footer .tabulator-pages {
    display: inline-flex !important;
    flex-wrap: wrap;
    justify-content: center;
    gap: 2px;
  }

  /* View tabs scroll on tablet */
  .rv-page .tb-view-area {
    border-radius: 8px 8px 0 0;
  }

  .rv-page .tb-view-area .v-slide-group__wrapper {
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch;
  }

  .rv-page .tb-view-area .v-tab {
    font-size: 0.72rem !important;
    padding: 0 10px !important;
  }

  /* View buttons (New View / Save) */
  .rv-page .tb-view-area .tb-view-dropdown-btn {
    font-size: 0.72rem !important;
    padding: 0 8px !important;
    min-width: auto !important;
  }
}

@media (max-width: 599px) {
  /* Table horizontal scroll */
  .tabulator {
    border-radius: 0 !important;
  }

  .tabulator .tabulator-header .tabulator-col .tabulator-col-content {
    padding: 8px 8px !important;
  }

  .tabulator .tabulator-header .tabulator-col .tabulator-col-title {
    font-size: 0.62rem !important;
    letter-spacing: 0.5px !important;
  }

  .tabulator .tabulator-tableholder .tabulator-table .tabulator-row .tabulator-cell {
    font-size: 0.72rem !important;
    padding: 6px 6px !important;
  }

  /* Smaller pills on mobile */
  .tbl-pill {
    font-size: 0.68rem !important;
    padding: 2px 8px !important;
  }

  .tbl-price-badge {
    font-size: 0.68rem !important;
    padding: 2px 8px !important;
  }

  .tbl-price-badge__currency {
    font-size: 0.58rem !important;
  }

  .tbl-company-link {
    font-size: 0.72rem !important;
  }

  .tbl-stage {
    font-size: 0.7rem !important;
  }

  .tbl-idx {
    width: 22px;
    height: 22px;
    font-size: 0.65rem !important;
    border-radius: 6px;
  }

  .tbl-idx-badge {
    width: 16px;
    height: 16px;
    border-radius: 4px;
    margin-left: 2px;
  }

  .tbl-actions-btn {
    font-size: 0.62rem !important;
    padding: 4px 8px !important;
    letter-spacing: 0.3px !important;
  }

  .tbl-flag {
    width: 24px;
    height: 24px;
    border-radius: 6px;
  }

  .tbl-flag .v-icon {
    font-size: 14px !important;
  }

  .tbl-next-btn {
    width: 26px;
    height: 26px;
    border-radius: 6px;
  }

  .tbl-next-btn .v-icon {
    font-size: 14px !important;
  }

  /* Footer compact on mobile */
  .tabulator .tabulator-footer {
    padding: 8px 8px !important;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  .tabulator .tabulator-footer .tabulator-paginator {
    flex-wrap: wrap;
    justify-content: center !important;
    gap: 4px;
  }

  .tabulator .tabulator-footer .tabulator-page-counter {
    width: 100%;
    text-align: center;
    font-size: 0.68rem !important;
  }

  .tabulator .tabulator-footer .tabulator-page {
    font-size: 0.68rem !important;
    padding: 3px 7px !important;
  }

  .tabulator .tabulator-footer .tabulator-page-size {
    font-size: 0.72rem !important;
  }

  /* View tabs */
  .rv-page .tb-view-area {
    border-radius: 0;
    padding: 0 4px;
  }

  .rv-page .tb-view-area .v-tab {
    font-size: 0.68rem !important;
    padding: 0 8px !important;
    min-width: auto !important;
  }
}

/* ============================================
   DARK MODE — SCOPED
   ============================================ */
/* .rv-page and .rv-card-wrapper are NOT re-declared here. This block is not
   scoped, so `.dark-mode .rv-page` is (0,2,0) — the same specificity as the
   scoped `.rv-page[data-v-…]` above but later in the file, so it would win on
   order alone and repaint the frosted sheet an opaque --app-page in dark mode
   only. Both surfaces are token-driven above and need no dark companion. */
.dark-mode .page-toolbar__title { color: var(--app-text); }
.dark-mode .page-toolbar__count { color: var(--app-text-faint); }
.dark-mode .filter-bar__toggle { background: var(--app-page); border-color: var(--app-border); color: var(--app-text); }
.dark-mode .filter-bar__toggle:hover { background: var(--app-card); border-color: var(--app-border-strong); }
.dark-mode .filter-panel { background: var(--app-card); border-color: var(--app-border); }
.dark-mode .filter-panel__columns { background: var(--app-page); border-color: var(--app-border); }
.dark-mode .rv-dialog__card { background: var(--app-card); }
.dark-mode .rv-dialog__body { color: var(--app-text); }
.dark-mode .rv-dialog__label { color: var(--app-text-muted); }

/* ============================================
   DARK MODE — TABULATOR (unscoped)
   ============================================ */
.dark-mode .tabulator .tabulator-header { background-color: var(--app-page) !important; border-color: var(--app-border) !important; }
.dark-mode .tabulator .tabulator-header .tabulator-col { background-color: var(--app-page) !important; border-color: var(--app-border) !important; }
.dark-mode .tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-col-title { color: var(--app-text-muted) !important; }
.dark-mode .tabulator .tabulator-row { border-color: var(--app-border) !important; }
.dark-mode .tabulator .tabulator-row:hover { background-color: var(--app-border) !important; }
.dark-mode .tabulator .tabulator-cell { color: var(--app-text) !important; border-color: var(--app-card) !important; }
.dark-mode .tabulator .tabulator-footer { background-color: var(--app-page) !important; border-color: var(--app-border) !important; }
.dark-mode .tabulator .tabulator-footer .tabulator-page { background: var(--app-card) !important; border-color: var(--app-border) !important; color: var(--app-text-muted) !important; }
.dark-mode .tabulator .tabulator-footer .tabulator-page:hover:not(.disabled):not([disabled]) { background: var(--app-border) !important; border-color: var(--app-border-strong) !important; color: var(--app-text) !important; }
.dark-mode .tabulator .tabulator-footer .tabulator-page.active { background: var(--app-accent) !important; border-color: var(--app-accent) !important; color: var(--app-accent-fg) !important; }
.dark-mode .tabulator .tabulator-footer .tabulator-page-counter { color: var(--app-text-muted) !important; }
.dark-mode .tabulator .tabulator-footer .tabulator-page-size { background: var(--app-card) !important; border-color: var(--app-border) !important; color: var(--app-text) !important; }
.dark-mode .custom-pagesize__trigger { background: var(--app-card); border-color: var(--app-border); color: var(--app-text); }
.dark-mode .custom-pagesize__menu { background: var(--app-card); border-color: var(--app-border); }
.dark-mode .custom-pagesize__item { color: var(--app-text); }
.dark-mode .custom-pagesize__item:hover { background: var(--app-border); }
.dark-mode .custom-pagesize__item--active { background: var(--app-accent-soft); color: var(--app-accent); }
.dark-mode .rv-page .tb-view-area { background: var(--app-page) !important; border-color: var(--app-border) !important; }
.dark-mode .rv-page .tb-view-area .v-tabs { background: transparent !important; }
.dark-mode .rv-page .tb-view-area .v-tabs-bar { background: transparent !important; }
.dark-mode .rv-page .tb-view-area .v-slide-group__wrapper { background: transparent !important; }
.dark-mode .rv-page .tb-view-area .v-slide-group__content { background: transparent !important; }
.dark-mode .rv-page .tb-view-area .v-slide-group__prev,
.dark-mode .rv-page .tb-view-area .v-slide-group__next { background: var(--app-page) !important; }
.dark-mode .rv-page .tb-view-area .v-tab { color: var(--app-text-muted) !important; background: transparent !important; }
.dark-mode .rv-page .tb-view-area .v-tab:hover { color: var(--app-text) !important; background: var(--app-card) !important; }
.dark-mode .rv-page .tb-view-area .v-tab--active { color: var(--app-accent) !important; background: var(--app-card) !important; }
.dark-mode .rv-page .tb-view-area .col-md-2 { background: transparent !important; }
.dark-mode .tbl-next-btn { background: var(--app-card); border-color: var(--app-border); }
.dark-mode .tbl-next-btn:hover { background: var(--app-accent-soft); border-color: var(--app-accent); }
/* Actions button keeps the theme blue in dark mode instead of going grey —
   a tinted accent fill at rest, solid accent on hover (same shape as light). */
.dark-mode .tbl-actions-btn {
  background: var(--app-accent-soft);
  border-color: var(--app-accent-border);
  color: var(--app-accent-strong);
}
.dark-mode .tbl-actions-btn:hover {
  background: var(--app-accent);
  border-color: var(--app-accent);
  color: var(--app-accent-fg);
  box-shadow: 0 2px 8px var(--app-accent-glow);
}

/* Search bar inputs (BreadTabulatorSearchable) */
.dark-mode .search-select .v-input__slot,
.dark-mode .search-input .v-input__slot,
.dark-mode .tb-select .v-input__slot,
.dark-mode .tb-text-filed .v-input__slot,
.dark-mode .tb-with-textfield-clear .v-input__slot {
  background: var(--app-page) !important;
  border-color: var(--app-border) !important;
  color: var(--app-text) !important;
}
.dark-mode .search-select .v-select__selection,
.dark-mode .search-input input,
.dark-mode .tb-select .v-select__selection,
.dark-mode .tb-text-filed input {
  color: var(--app-text) !important;
}
.dark-mode .search-select .v-label,
.dark-mode .search-input .v-label,
.dark-mode .tb-select .v-label,
.dark-mode .tb-text-filed .v-label {
  color: var(--app-text-faint) !important;
}
.dark-mode .search-bar__btn--clear {
  background: var(--app-card) !important;
  border-color: var(--app-border) !important;
  color: var(--app-text-muted) !important;
}

/* Export As button */
.dark-mode .rv-page .page-toolbar__right .v-btn-toggle .v-btn--tile {
  background: var(--app-card) !important;
  border-color: var(--app-border) !important;
  color: var(--app-text) !important;
}
.dark-mode .rv-page .page-toolbar__right .v-btn-toggle .v-btn--tile:hover {
  background: var(--app-border) !important;
}
.dark-mode .rv-page .page-toolbar__right .v-btn-toggle {
  background: transparent !important;
}

/* New View / Save buttons */
.dark-mode .rv-page .col-md-2 .v-btn--tile.v-btn--outlined {
  background: var(--app-card) !important;
  border-color: var(--app-border) !important;
  color: var(--app-text) !important;
}
.dark-mode .rv-page .col-md-2 .v-btn--tile.v-btn--outlined:hover {
  background: var(--app-border) !important;
}
.dark-mode .rv-page .col-md-2 .v-btn--tile.v-btn--outlined.v-btn--disabled {
  color: var(--app-text-faint) !important;
}

/* View tabs list menu button.
   The strip behind it is --app-page, so --app-card here was a ~7-point
   lightness jump — the light-mode pair it mirrors (#fff on #f8fafc) is only
   ~1.7. --app-surface keeps the button reading as a raised control at a step
   size proportionate to the strip, and hover lifts to --app-elevated rather
   than jumping all the way to the border grey. */
.dark-mode .rv-page .tb-view-area > .col-md-10 > .v-btn {
  background: var(--app-surface) !important;
  border-color: var(--app-border) !important;
}
.dark-mode .rv-page .tb-view-area > .col-md-10 > .v-btn .v-icon {
  color: var(--app-text-muted) !important;
}
.dark-mode .rv-page .tb-view-area > .col-md-10 > .v-btn:hover {
  background: var(--app-elevated) !important;
}

/* Table wrapper and tabulator bg */
.dark-mode .table-scroll-wrapper {
  background: var(--app-card);
}
.dark-mode .tabulator {
  background: var(--app-card) !important;
  border-color: var(--app-border) !important;
}
.dark-mode .tabulator .tabulator-tableholder {
  background: var(--app-card) !important;
}

/* Filter panel inputs */
.dark-mode .filter-panel .v-input__slot {
  background: var(--app-page) !important;
  border-color: var(--app-border) !important;
}
.dark-mode .filter-panel .v-select__selection,
.dark-mode .filter-panel .v-text-field__slot input {
  color: var(--app-text) !important;
}
.dark-mode .filter-panel .v-label {
  color: var(--app-text-faint) !important;
}
.dark-mode .filter-panel .tb-btn {
  background: var(--app-accent) !important;
}
.dark-mode .filter-panel .tb-btn-clear {
  background: var(--app-card) !important;
  border-color: var(--app-border) !important;
  color: var(--app-text-muted) !important;
}
.dark-mode .filter-panel .tb-filter-applied h4 {
  color: var(--app-text-faint);
}
.dark-mode .filter-panel .v-chip {
  background: var(--app-warning-bg) !important;
  color: var(--app-warning-fg) !important;
}

/* Column selector inside filter */
.dark-mode .filter-panel__columns .tb-select-column-dropdown .v-input__slot {
  background: var(--app-page) !important;
  border-color: var(--app-border) !important;
}
.dark-mode .filter-panel__columns .tb-select-column-dropdown .v-chip {
  background: var(--app-accent-soft) !important;
  color: var(--app-accent) !important;
}
.dark-mode .filter-panel__columns .tb-clear-btn {
  background: var(--app-card) !important;
  border-color: var(--app-border) !important;
  color: var(--app-text-muted) !important;
}

/* Tabulator row background (even/odd) */
.dark-mode .tabulator .tabulator-tableholder .tabulator-table .tabulator-row {
  background-color: var(--app-card) !important;
}
.dark-mode .tabulator .tabulator-tableholder .tabulator-table .tabulator-row.tabulator-selected {
  background-color: var(--app-accent-soft) !important;
}
.dark-mode .tabulator .tabulator-tableholder .tabulator-table .tabulator-row.tabulator-selected:hover {
  background-color: var(--app-accent-soft) !important;
}

/* Tabulator checkbox dark mode */
.dark-mode .tabulator .tabulator-row .tabulator-cell input[type="checkbox"],
.dark-mode .tabulator .tabulator-header .tabulator-col input[type="checkbox"] {
  background: var(--app-page);
  border-color: var(--app-border-strong);
}

/* Stage alert badges */
.tbl-stage-alert {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 8px;
  border-radius: 6px;
  font-family: "Lato", sans-serif;
  white-space: nowrap;
}

.tbl-stage-alert--success {
  background: #dcfce7;
  color: #16a34a;
}

.tbl-stage-alert--error {
  background: #fee2e2;
  color: #dc2626;
}

.tbl-stage-alert--warning {
  background: #fef3c7;
  color: #d97706;
}

.tbl-stage-alert__text {
  font-size: 0.72rem;
  font-weight: 700;
}

.tbl-stage-alert svg {
  flex-shrink: 0;
}
</style>
